export class LiveNewsContentEntity {
    constructor(category, desc, timeText, chgP, dpName, hghlTxt, sym) {
        this.category = category;
        this.desc = desc;
        this.timeText = timeText;
        this.chgP = chgP;
        this.dpName = dpName;
        this.hghlTxt = hghlTxt;
        this.sym = sym;
    }
}
